import apiService from 'src/shared/config/apiService';
import { Rfq } from 'src/shared/types/rfq';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getRfq = async (rfqId: string): Promise<Rfq> => {
  try {
    const response = await apiService.get(`/rfqs/${rfqId}`);

    return response?.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getRfq;
